import React from "react";
import { Button } from "react-bootstrap";

export const exportToCSV = (title, columns, data, filenamePrefix = "Export") => {
  if (!data || data.length === 0) {
    alert("No data available to export.");
    return;
  }

  let csvContent = "";
  csvContent += `"${title}"\n`;
  csvContent += `"Generated On","${new Date().toLocaleString("en-IN")}"\n\n`;

  const validCols = columns.filter(
    (c) => c.Header && c.id !== "actions" && c.id !== "approval" && c.id !== "row"
  );
  const headers = validCols.map((c) => c.Header);
  csvContent += headers.map((h) => `"${h}"`).join(",") + "\n";

  data.forEach((r) => {
    const rowValues = validCols.map((col) => {
      let val = col.accessor ? r[col.accessor] : "";
      if (val === null || val === undefined) val = "-";
      if (typeof val === "object") val = JSON.stringify(val);
      return String(val).replace(/"/g, '""');
    });
    csvContent += rowValues.map((v) => `"${v}"`).join(",") + "\n";
  });

  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.setAttribute("href", url);
  link.setAttribute(
    "download",
    `${filenamePrefix.replace(/\s+/g, "_")}_${new Date().toISOString().split("T")[0]}.csv`
  );
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export const exportToPDF = (title, columns, data) => {
  if (!data || data.length === 0) {
    alert("No data available to export.");
    return;
  }

  const printWindow = window.open("", "_blank");
  if (!printWindow) {
    alert("Popup blocked! Please allow popups to export PDF.");
    return;
  }

  const validCols = columns.filter(
    (c) => c.Header && c.id !== "actions" && c.id !== "approval" && c.id !== "row"
  );

  const headerHtml = `<tr><th>#</th>` + validCols.map((c) => `<th>${c.Header}</th>`).join("") + `</tr>`;

  let rowsHtml = "";
  data.forEach((r, idx) => {
    let cellsHtml = `<td>${idx + 1}</td>`;
    validCols.forEach((col) => {
      let val = col.accessor ? r[col.accessor] : "";
      if (val === null || val === undefined) val = "-";
      cellsHtml += `<td>${val}</td>`;
    });
    rowsHtml += `<tr>${cellsHtml}</tr>`;
  });

  printWindow.document.write(`
    <html>
      <head>
        <title>${title}</title>
        <style>
          body { font-family: 'Segoe UI', Arial, sans-serif; padding: 20px; color: #333; }
          .header { display: flex; justify-content: space-between; border-bottom: 2px solid #E87B2D; padding-bottom: 10px; margin-bottom: 15px; }
          .company-name { font-size: 22px; font-weight: bold; color: #E87B2D; }
          .report-title { font-size: 16px; font-weight: bold; text-align: right; }
          table { width: 100%; border-collapse: collapse; margin-top: 10px; font-size: 11px; }
          th, td { border: 1px solid #dee2e6; padding: 6px 8px; text-align: left; }
          th { background-color: #E87B2D; color: white; text-transform: uppercase; font-size: 10px; }
          tr:nth-child(even) { background-color: #f9f9f9; }
          @media print {
            body { padding: 0; }
            th { background-color: #E87B2D !important; color: white !important; -webkit-print-color-adjust: exact; print-color-adjust: exact; }
          }
        </style>
      </head>
      <body>
        <div class="header">
          <div class="company-name">KIRAYAGO</div>
          <div class="report-title">${title}</div>
        </div>
        <div style="margin-bottom: 15px; font-size: 11px; color: #666;">
          Generated On: ${new Date().toLocaleString("en-IN")} | Total Records: ${data.length}
        </div>
        <table>
          <thead>${headerHtml}</thead>
          <tbody>${rowsHtml}</tbody>
        </table>
        <script>
          window.onload = function() {
            setTimeout(function() {
              window.print();
              window.close();
            }, 300);
          };
        </script>
      </body>
    </html>
  `);
  printWindow.document.close();
};

const ExportButtons = ({ title = "Report", columns = [], data = [], filename = "Export" }) => {
  return (
    <div style={{ display: "flex", gap: 6, alignItems: "center" }}>
      <Button
        size="sm"
        variant="outline-success"
        className="py-0 px-2"
        style={{ fontSize: 11, fontWeight: 600, height: 26, display: "flex", alignItems: "center", gap: 4 }}
        onClick={() => exportToCSV(title, columns, data, filename)}
      >
        <span>📊</span> Export Excel
      </Button>
      <Button
        size="sm"
        variant="outline-danger"
        className="py-0 px-2"
        style={{ fontSize: 11, fontWeight: 600, height: 26, display: "flex", alignItems: "center", gap: 4 }}
        onClick={() => exportToPDF(title, columns, data)}
      >
        <span>🖨️</span> Export PDF
      </Button>
    </div>
  );
};

export default ExportButtons;
